import { Link } from 'react-router-dom';
import { ArrowRight, Zap } from 'lucide-react';
import { useTr } from '../contexts/LanguageContext';

const UltraMindBanner = () => {
  const t = useTr();
  return (
    <section
      style={{ position: 'relative', zIndex: 10, background: '#000000', borderTop: '1px solid rgba(48,213,200,0.1)', borderBottom: '1px solid rgba(48,213,200,0.1)', overflow: 'hidden' }}
      data-testid="ultramind-banner"
    >
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 70% 100% at 60% 50%, rgba(48,213,200,0.07) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 md:px-10 py-14 sm:py-18 md:py-20 relative">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 mb-4">
              <Zap size={13} color="#30d5c8" />
              <span className="text-xs font-mono text-[#30d5c8] tracking-[0.3em] uppercase">{t('Now Available', '지금 이용 가능')}</span>
            </div>
            <h2 className="font-outfit font-black text-white tracking-tighter leading-tight mb-4" style={{ fontSize: 'clamp(28px, 5vw, 52px)' }}>
              {t('Introducing', '소개합니다')}{' '}
              <span className="gradient-text">UltraMind</span>
            </h2>
            <p className="text-white/55 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl">
              {t(
                'The autonomous economy layer built on SwarmBase. Point it at a business objective and it stands up a company staffed by agents, operates it, pays its suppliers, bills its customers, and keeps going with nobody running it.',
                'SwarmBase 위에 구축된 자율 경제 레이어입니다. 비즈니스 목표를 입력하면, AI 에이전트로 구성된 회사를 구축하고 운영하며, 공급업체에 지불하고, 고객에게 청구하면서 아무도 관리하지 않아도 계속 운영됩니다.'
              )}
            </p>
            <p className="text-white/32 text-sm font-mono mt-3">
              {t('SwarmBase executes tasks. UltraMind pursues goals.', 'SwarmBase는 작업을 실행합니다. UltraMind는 목표를 추구합니다.')}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row lg:flex-col gap-3 flex-shrink-0">
            <Link to="/ultra"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded font-bold text-base transition-all duration-300"
              style={{ background: '#30d5c8', color: '#000000', boxShadow: '0 0 32px rgba(48,213,200,0.45), 0 0 80px rgba(48,213,200,0.15)', minWidth: 200 }}
              onMouseEnter={e => { e.currentTarget.style.background = '#55d532'; e.currentTarget.style.boxShadow = '0 0 32px rgba(85,213,50,0.45), 0 0 80px rgba(85,213,50,0.15)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#30d5c8'; e.currentTarget.style.boxShadow = '0 0 32px rgba(48,213,200,0.45), 0 0 80px rgba(48,213,200,0.15)'; }}
              data-testid="ultramind-open-btn">
              {t('Open UltraMind', 'UltraMind 열기')} <ArrowRight size={18} />
            </Link>
            <a href="/ultramind-whitepaper.pdf" download="UltraMind-Whitepaper.pdf"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded font-semibold text-sm transition-all duration-300"
              style={{ border: '1px solid rgba(48,213,200,0.4)', color: '#30d5c8', background: 'transparent', minWidth: 200 }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(48,213,200,0.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
              data-testid="ultramind-download-home-btn">
              {t('Download Whitepaper', '백서 다운로드')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UltraMindBanner;
